/* Dims shipping-bar. Variant A (25-09-2026): fri fragt-besked + 3 USP'er på da/de/en/fr/pl/sv (NEWT).
   Julebytte 1/12 til 24/12-2026: fjerde punkt er julebyttet (JUL_SLUT nedenfor), derefter "+40.000 ordrer" igen.
   Upublicerede sprog kører videre med den gamle enkeltlinje-tekst (OLD).
   Config fra #dims-shipping-bar-msg data-*; tærskel/valuta sættes af Liquid pr. valuta.
   Desktop: alle punkter på én linje (alle 4 punkter fra 1200px). Under 1200px roterer punkterne.
   Styling ligger i sections/announcement-bar.liquid. */
/* Temaet sender ingen kurv-events ved "Læg i kurv". Vi lytter derfor på kurv-kald
   (fetch og XHR til /cart/add, /cart/change, /cart/update, /cart/clear) og sender "dims:cart". */
(function(){
  if (window.__dimsCartHook) return; window.__dimsCartHook = true;
  var RE = /\/cart\/(add|change|update|clear)/;
  function fire(){ setTimeout(function(){ document.dispatchEvent(new CustomEvent('dims:cart')); }, 60); }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (RE.test(url)) p.then(fire, fire);
      return p;
    };
  }
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, url){
    if (RE.test(url || '')) this.addEventListener('loadend', fire);
    return oo.apply(this, arguments);
  };
})();

(function () {
  var NEWT = {
  "da": {
    "dflt": "Fragt fra 39,- og <b>Gratis Fragt over {t}</b>",
    "below": "Køb for <b>{a}</b> mere, så er fragten gratis",
    "above": "Tillykke, <b>du har gratis fragt!</b> <span class=\"dp-party\">🎉</span>",
    "noFree": "Billig fragt til Europa",
    "fast": "Lynhurtig levering 1-2 hverdage",
    "tpw": "Fremragende",
    "tp": "4,9 på Trustpilot",
    "orders": "<b>+40.000</b> ordrer",
    "xmas": "<b>Julebytte</b> til og med 10. januar"
  },
  "de": {
    "dflt": "Versand ab 7,95 € · Gratis Versand ab <b>{t}</b>",
    "below": "Noch <b>{a}</b> bis zum Gratisversand",
    "above": "Super, kostenloser Versand erzielt! <span class=\"dp-party\">🎉</span>",
    "noFree": "Günstige Lieferung nach Europa",
    "fast": "Blitzschnelle Lieferung in 1-2 Werktagen",
    "tpw": "Hervorragend",
    "tp": "4,9 auf Trustpilot",
    "orders": "<b>+40.000</b> Bestellungen",
    "xmas": "<b>Umtausch</b> bis 10. Januar"
  },
  "en": {
    "dflt": "Shipping from €7.95 · Free shipping over <b>{t}</b>",
    "below": "Add <b>{a}</b> more for free shipping",
    "above": "Great, you’ve got free shipping! <span class=\"dp-party\">🎉</span>",
    "noFree": "Cheap shipping to Europe",
    "fast": "Fast delivery in 1-2 business days",
    "tpw": "Excellent",
    "tp": "4.9 on Trustpilot",
    "orders": "<b>40,000+</b> orders",
    "xmas": "<b>Exchanges</b> until 10 January"
  },
  "fr": {
    "dflt": "Livraison dès 7,95 € · Livraison offerte dès <b>{t}</b>",
    "below": "Plus que <b>{a}</b> pour la livraison offerte",
    "above": "Super, vous bénéficiez de la livraison offerte ! <span class=\"dp-party\">🎉</span>",
    "noFree": "Livraison économique en Europe",
    "fast": "Livraison rapide en 1-2 jours ouvrés",
    "tpw": "Excellent",
    "tp": "4,9 sur Trustpilot",
    "orders": "<b>+40 000</b> commandes",
    "xmas": "<b>Échanges</b> jusqu’au 10 janvier"
  },
  "pl": {
    "dflt": "Dostawa od 7,95 € · Darmowa dostawa powyżej <b>{t}</b>",
    "below": "Jeszcze <b>{a}</b> do darmowej dostawy",
    "above": "Świetnie, darmowa dostawa! <span class=\"dp-party\">🎉</span>",
    "noFree": "Tania wysyłka do Europy",
    "fast": "Błyskawiczna dostawa w 1-2 dni robocze",
    "tpw": "Doskonała",
    "tp": "4,9 na Trustpilot",
    "orders": "<b>+40 000</b> zamówień",
    "xmas": "<b>Wymiana</b> do 10 stycznia"
  },
  "sv": {
    "dflt": "Frakt från 49 kr · <b>Fri frakt över {t}</b>",
    "below": "Handla för <b>{a}</b> till, så får du fri frakt",
    "above": "Grattis, du har uppnått Gratis Frakt! <span class=\"dp-party\">🎉</span>",
    "noFree": "Billig frakt till Europa",
    "fast": "Snabb leverans 1-2 vardagar",
    "tpw": "Utmärkt",
    "tp": "4,9 på Trustpilot",
    "orders": "<b>+40 000</b> ordrar",
    "xmas": "<b>Julbyte</b> till och med 10 januari"
  }
};

  var OLD = {
    'da': {
      dflt:   '✔️ Fragt fra 39,- og Gratis Fragt over {t}',
      below:  'Køb for {a} mere for Gratis Fragt',
      above:  '✔️ Tillykke – du har opnået Gratis Fragt!',
      noFree: '✔️ Billig fragt til Europa',
      suffix: '✔️ 1-2 hverdages levering ✔️ 4.9 / 5.0 på Trustpilot'
    },
    'en': {
      dflt:   '✔️ Shipping from €7.95 · Free shipping over {t}',
      below:  'Add {a} more for free shipping',
      above:  '✔️ Great – you’ve got free shipping!',
      noFree: '✔️ Cheap shipping to Europe',
      suffix: '✔️ 1-2 business days ✔️ 4.9 / 5.0 on Trustpilot'
    },
    'sv': {
      dflt:   '✔️ Frakt från 49 kr · Gratis frakt över {t}',
      below:  'Köp för {a} mer för Gratis Frakt',
      above:  '✔️ Grattis – du har uppnått Gratis Frakt!',
      noFree: '✔️ Billig frakt till Europa',
      suffix: '✔️ 1-2 vardagars leverans ✔️ 4,9 / 5,0 på Trustpilot'
    },
    'de': {
      dflt:   '✔️ Versand ab 7,95 € · Gratis Versand ab {t}',
      below:  'Noch {a} bis zum Gratisversand',
      above:  '✔️ Super – kostenloser Versand erzielt!',
      noFree: '✔️ Günstige Lieferung nach Europa',
      suffix: '✔️ 1-2 Werktage ✔️ 4,9 / 5,0 auf Trustpilot'
    },
    'fr': {
      dflt:   '✔️ Livraison dès 7,95 € · Livraison offerte dès {t}',
      below:  'Plus que {a} pour la livraison offerte',
      above:  '✔️ Super – vous bénéficiez de la livraison offerte !',
      noFree: '✔️ Livraison économique en Europe',
      suffix: '✔️ 1-2 jours ouvrés ✔️ 4,9 / 5,0 sur Trustpilot'
    },
    'nl': {
      dflt:   '✔️ Verzending vanaf €7,95 · Gratis verzending boven {t}',
      below:  'Nog {a} voor gratis verzending',
      above:  '✔️ Gefeliciteerd – gratis verzending bereikt!',
      noFree: '✔️ Voordelige verzending naar Europa',
      suffix: '✔️ 1-2 werkdagen ✔️ 4,9 / 5,0 op Trustpilot'
    },
    'it': {
      dflt:   '✔️ Spedizione da 7,95 € · Spedizione gratuita sopra {t}',
      below:  'Ancora {a} per la spedizione gratuita',
      above:  '✔️ Ottimo – spedizione gratuita raggiunta!',
      noFree: '✔️ Spedizione economica in Europa',
      suffix: '✔️ 1-2 giorni lavorativi ✔️ 4,9 / 5,0 su Trustpilot'
    },
    'es': {
      dflt:   '✔️ Envío desde 7,95 € · Envío gratis a partir de {t}',
      below:  'Faltan {a} para el envío gratis',
      above:  '✔️ ¡Genial – envío gratis conseguido!',
      noFree: '✔️ Envío económico a Europa',
      suffix: '✔️ 1-2 días hábiles ✔️ 4,9 / 5,0 en Trustpilot'
    },
    'pl': {
      dflt:   '✔️ Dostawa od 7,95 € · Darmowa dostawa powyżej {t}',
      below:  'Jeszcze {a} do darmowej dostawy',
      above:  '✔️ Świetnie – darmowa dostawa!',
      noFree: '✔️ Tania wysyłka do Europy',
      suffix: '✔️ 1-2 dni robocze ✔️ 4,9 / 5,0 na Trustpilot'
    },
    'fi': {
      dflt:   '✔️ Toimitus alkaen 7,95 € · Ilmainen toimitus yli {t}',
      below:  'Lisää {a} ilmaiseen toimitukseen',
      above:  '✔️ Hienoa – ilmainen toimitus!',
      noFree: '✔️ Edullinen toimitus Eurooppaan',
      suffix: '✔️ 1-2 arkipäivää  ✔️ Hintavertailu  ✔️ 4,9 / 5,0 Trustpilotissa'
    },
    'ro': {
      dflt:   '✔️ Livrare de la 7,95 € · Livrare gratuită de la {t}',
      below:  'Mai adaugă {a} pentru livrare gratuită',
      above:  '✔️ Felicitări – ai livrare gratuită!',
      noFree: '✔️ Livrare ieftină în Europa',
      suffix: '✔️ 1-2 zile lucrătoare ✔️ 4,9 / 5,0 pe Trustpilot'
    },
    'cs': {
      dflt:   '✔️ Doprava od 7,95 € · Doprava zdarma nad {t}',
      below:  'Do dopravy zdarma zbývá {a}',
      above:  '✔️ Skvěle – doprava zdarma!',
      noFree: '✔️ Levné doručení do Evropy',
      suffix: '✔️ 1-2 pracovní dny ✔️ 4,9 / 5,0 na Trustpilot'
    },
    'no': {
      dflt:   '✔️ Frakt fra 49 kr · Gratis frakt over {t}',
      below:  'Kjøp for {a} mer for Gratis Frakt',
      above:  '✔️ Flott – du har oppnådd Gratis Frakt!',
      noFree: '✔️ Billig frakt til Europa',
      suffix: '✔️ 1-2 virkedager ✔️ 4,9 / 5,0 på Trustpilot'
    }
  };

  var FMT = {
    'DKK': function(c) { return Math.ceil(c / 100).toLocaleString('da-DK') + ' kr.'; },
    'SEK': function(c) { return Math.ceil(c / 100).toLocaleString('sv-SE') + ' kr.'; },
    'EUR': function(c) { return Math.ceil(c / 100).toLocaleString('de-DE') + ' €'; },
    'PLN': function(c) { return Math.ceil(c / 100).toLocaleString('pl-PL') + ' zł'; },
    'CZK': function(c) { return Math.ceil(c / 100).toLocaleString('cs-CZ') + ' Kč'; },
    'RON': function(c) { return Math.ceil(c / 100).toLocaleString('ro-RO') + ' lei'; }
  };

  var TRUCK = '<svg class="dp-truck" viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';
  var STAR = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>';

  function run() {
    var el = document.getElementById('dims-shipping-bar-msg');
    if (!el) return;

    var threshold  = parseFloat(el.dataset.threshold  || '0') * 100;
    var currency   = el.dataset.currency   || 'DKK';
    var noFree     = el.dataset.noFree     === 'true';
    var threshDisp = el.dataset.thresholdDisplay || '';

    var lang = (document.documentElement.lang || 'da').split('-')[0].toLowerCase();
    var isNew = !!NEWT[lang];
    var tr   = isNew ? NEWT[lang] : (OLD[lang] || OLD['en']);
    var fmt  = FMT[currency] || FMT['DKK'];
    var idx  = 0;

    if (!isNew) el.classList.add('dp-legacy');

    // Julebytte 1/12 til 24/12-2026: fjerde punkt er julebyttet. Fra 25/12 kl. 00.00 dansk tid igen "+40.000 ordrer".
    var JUL_SLUT = Date.UTC(2026, 11, 24, 23, 0, 0);
    var jul = isNew && !!tr.xmas && Date.now() < JUL_SLUT;
    var usps = isNew ?
      '<span class="dp-div" aria-hidden="true"></span><div class="dp-item dp-usp"><span class="dp-emo" aria-hidden="true">⚡</span>' + tr.fast + '</div>' +
      '<span class="dp-div" aria-hidden="true"></span><div class="dp-item dp-usp"><span class="dp-stars" role="img" aria-label="5 stjerner">' + STAR + STAR + STAR + STAR + STAR + '</span><b>' + tr.tpw + '</b>&nbsp;' + tr.tp + '</div>' +
      (jul
        ? '<span class="dp-div" aria-hidden="true"></span><div class="dp-item dp-usp"><span class="dp-emo" aria-hidden="true">🎁</span>' + tr.xmas + '</div>'
        : '<span class="dp-div dp-xl" aria-hidden="true"></span><div class="dp-item dp-usp dp-xl"><span class="dp-emo" aria-hidden="true">📦</span>' + tr.orders + '</div>')
      : (tr.suffix ? ' <span class="dims-bar-sep">·</span> ' + tr.suffix : '');

    function mark() {
      var items = el.querySelectorAll('.dp-item');
      for (var i = 0; i < items.length; i++) items[i].classList.toggle('on', i === idx);
    }

    function update(totalCents) {
      var html;
      if (noFree || threshold <= 0) {
        html = tr.noFree;
      } else if (totalCents <= 0) {
        html = tr.dflt.replace('{t}', threshDisp);
      } else if (totalCents >= threshold) {
        html = tr.above;
      } else {
        html = tr.below.replace('{a}', fmt(threshold - totalCents));
      }
      if (isNew) {
        el.innerHTML = '<div class="dp-item dp-main">' + TRUCK + '<span>' + html + '</span></div>' + usps;
        mark();
      } else {
        el.innerHTML = html + usps;
      }
    }

    update(0);
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(c) { update(c.total_price); })
      .catch(function()  {});

    document.addEventListener('dims:cart', function() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { update(c.total_price); });
    });
    document.addEventListener('cart:refresh', function() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { update(c.total_price); });
    });
    document.addEventListener('cart:updated', function(e) {
      if (e.detail && e.detail.cart) update(e.detail.cart.total_price);
      else fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { update(c.total_price); });
    });

    if (!isNew) return;
    // Rotation på smalle skærme (kun synlig under 1200px via CSS)
    var mq = window.matchMedia('(max-width: 1199px)');
    setInterval(function () {
      if (!mq.matches) return;
      var n = el.querySelectorAll('.dp-item').length || 1;
      idx = (idx + 1) % n;
      mark();
    }, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
